module.exports = __webpack_public_path__ + "static/img/hero-3.b609360.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hero-3.jpg
// module id = P37I
// module chunks = 0